import { FC } from "react";

const Error403: FC = () => {
  return (
    <>
      <h1 className="fw-bolder fs-4x text-gray-700 mb-10">This record does not exist</h1>
    </>
  );
};

export { Error403 };
